import { AddressWithGeolocation, ProductTypes } from '~src/model';
import { deepNullToUndefined } from '~src/util';

import { useCalculateOfferTypeSavings } from './graphql/useOffer';
import { CUSTOMER_ADDRESS, useCachedState } from './useCachedState';

export const useOfferTypeSavings = (selectedProductTypes: ProductTypes = ['heatPump', 'solar']) => {
  const [address] = useCachedState<AddressWithGeolocation>(CUSTOMER_ADDRESS);

  const result = useCalculateOfferTypeSavings(address ?? {}, selectedProductTypes);

  return deepNullToUndefined(result.data?.offerTypeSavings);
};
